import "./styles.css";
import { createGame, type PlayerConfig } from "./game";

const form = document.querySelector<HTMLFormElement>("#player-setup");
const homepage = document.querySelector<HTMLElement>("#homepage");
const gameContainer = document.querySelector<HTMLElement>("#game-container");

if (!form || !homepage || !gameContainer) {
  throw new Error("Homepage DOM is missing required elements");
}

form.addEventListener("submit", (event) => {
  event.preventDefault();

  const data = new FormData(form);
  const config: { player1: PlayerConfig; player2: PlayerConfig } = {
    player1: {
      name: (data.get("p1-name") as string | null)?.trim() || "Player 1",
      vocation:
        (data.get("p1-vocation") as PlayerConfig["vocation"] | null) ??
        "warrior",
    },
    player2: {
      name: (data.get("p2-name") as string | null)?.trim() || "Player 2",
      vocation:
        (data.get("p2-vocation") as PlayerConfig["vocation"] | null) ??
        "warrior",
    },
  };

  homepage.hidden = true;
  gameContainer.hidden = false;

  createGame(gameContainer, config);
});
